// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__7kxI6","spinnerImg":"Spinner_spinnerImg__110HB"};